import { render } from "./directionalIcons.vue?vue&type=template&id=99c200c6&scoped=true"
import script from "./directionalIcons.vue?vue&type=script&lang=js"
export * from "./directionalIcons.vue?vue&type=script&lang=js"

import "./directionalIcons.vue?vue&type=style&index=0&id=99c200c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c200c6"]])

export default __exports__